import React, { Component, ReactNode } from "react";
import { ContentPageContext } from "./context";
import { ContentPage } from "services/entities/content";
import { Space } from "services/entities/spaces";

interface ContentPageProviderProps {
  url: string;
  children?: ReactNode | ReactNode[];
  pageData?: ContentPage | Space | null;
}

interface ContentPageProviderState {
  page: ContentPage | null;
}

export default class ContentPageProvider extends Component<
  ContentPageProviderProps,
  ContentPageProviderState
> {
  state = {
    page: null,
  };

  render() {
    return (
      <ContentPageContext.Provider value={this.state.page}>
        {this.props.children}
      </ContentPageContext.Provider>
    );
  }
}
